import { FrequencyUnit, ScheduleFrequency } from '@griply/types';

export const EVERY_DAY_RRULE = 'RRULE:FREQ=WEEKLY;BYDAY=MO,TU,WE,TH,FR,SA,SU';

export const EVERY_OTHER_DAY_RRULE = 'RRULE:FREQ=DAILY;INTERVAL=2';

export const MONTH_ORDINALS: readonly number[] = [1, 2, 3, 4, 5, -1];

export const MONTH_DAYS: readonly number[] = Array.from(
  { length: 31 },
  (_, index) => index + 1,
);

export const MONTHS: readonly number[] = Array.from(
  { length: 12 },
  (_, index) => index + 1,
);

export const defaultFrequency: ScheduleFrequency = {
  count: 1,
  unit: FrequencyUnit.Week,
  label: null,
};
